/**
 * month abbreviations styleguide:
 * https://abbreviations.yourdictionary.com/articles/standard-month-and-days-of-the-week-abbreviations.html */
export enum MonthAbbreviation {
    January = 'Jan.',
    February = 'Feb.',
    March = 'Mar.',
    April = 'Apr.',
    May = 'May',
    June = 'Jun.',
    July = 'Jul.',
    August = 'Aug.',
    September = 'Sept.',
    October = 'Oct.',
    November = 'Nov.',
    December = 'Dec.',
}
